
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/seo/SEO';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('privacy');

  return (
    <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white">
      <SEO
        title="Politique de confidentialité — Golf Progress Calculator"
        description="Découvrez comment Golf Progress Calculator collecte, utilise et protège vos données personnelles conformément au RGPD."
        path="/privacy"
      />
      <div className="container mx-auto py-8 px-4">
        <div className="mb-6">
          <Button variant="ghost" onClick={() => navigate(-1)} className="mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('back')}
          </Button>
        </div>

        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-2xl">{t('title')}</CardTitle>
            <p className="text-gray-600">{t('lastUpdated')} {new Date().toLocaleDateString(i18n.language === 'fr' ? 'fr-FR' : i18n.language === 'en' ? 'en-US' : 'es-ES')}</p>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('dataCollection.title')}</h2>
              <p className="mb-3">
                {t('dataCollection.intro')}
              </p>
              <ul className="list-disc list-inside space-y-1 mb-3">
                <li>{t('dataCollection.accountData')}</li>
                <li>{t('dataCollection.trainingData')}</li>
                <li>{t('dataCollection.locationData')}</li>
                <li>{t('dataCollection.technicalData')}</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('dataUsage.title')}</h2>
              <p className="mb-3">{t('dataUsage.intro')}</p>
              <ul className="list-disc list-inside space-y-1 mb-3">
                <li>{t('dataUsage.provideService')}</li>
                <li>{t('dataUsage.saveProgress')}</li>
                <li>{t('dataUsage.personalize')}</li>
                <li>{t('dataUsage.communicate')}</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('dataSharing.title')}</h2>
              <p className="mb-3">
                {t('dataSharing.intro')}
              </p>
              <ul className="list-disc list-inside space-y-1 mb-3">
                <li>{t('dataSharing.withConsent')}</li>
                <li>{t('dataSharing.legalCompliance')}</li>
                <li>{t('dataSharing.serviceProviders')}</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('yourRights.title')}</h2>
              <p className="mb-3">{t('yourRights.intro')}</p>
              <ul className="list-disc list-inside space-y-1 mb-3">
                <li>{t('yourRights.access')}</li>
                <li>{t('yourRights.rectify')}</li>
                <li>{t('yourRights.delete')}</li>
                <li>{t('yourRights.object')}</li>
                <li>{t('yourRights.portability')}</li>
              </ul>
              <p className="text-sm text-gray-600">
                {t('yourRights.contact')}
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('cookies.title')}</h2>
              <p className="mb-3">
                {t('cookies.content')}
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('security.title')}</h2>
              <p className="mb-3">
                {t('security.content')}
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('contact.title')}</h2>
              <p className="mb-3">
                {t('contact.intro')}
              </p>
              <ul className="list-disc list-inside space-y-1">
                <li>{t('contact.email')}</li>
                <li>{t('contact.form')}</li>
              </ul>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
